import { DataStore, Query, QueryResult } from 'src/core/stores/dataStore'
import { FormStore } from 'src/core/stores/formStore'
import { repository } from 'redux-scaffolding-ts'
import { container } from 'src/inversify.config'
import { Validator } from "lakmus"
import HttpService from '../core/services/http.service'
import autobind from 'autobind-decorator'
import { TimesheetItem, TimesheetSummary } from './timesheets-store'
import { unixEpochToDate } from '../core/utils/object'
import { ProjectSummary } from './projects-store'
import Showdown from 'showdown'
import { EmployeeSummary } from './employees-store'


export interface EmployeeBrief {
  title: string
  id: string
}


@repository("@@MYTIMESHEETS", "timesheets.summary")
export class MyTimesheetsStore extends DataStore<TimesheetSummary> {
  baseUrl: string = `${process.env.PUBLIC_URL}/api/v1/timesheet`;

  constructor() {
    super('MYTIMESHEET', {
      count: 0,
      isBusy: false,
      items: [],
      result: undefined,
      discard: item => { }
    }, container)
  }


  public async getMaxMIn(companyId: string, employeeId: string, showMyTeam: boolean = false, projectFilter: string[] = [], statusFilter: string[] = []) {
    let httpService = this.container.get<HttpService>(HttpService)
    var result
    var url = `${this.baseUrl}/${companyId}/${employeeId}/MaxMin?showMyTeam=` + showMyTeam
    if (projectFilter.length > 0) {
      const stringData = projectFilter.map((value) => `&projectFilters=${value}`).join('')
      url += stringData
    }
    if (statusFilter.length > 0) {
      const stringData = statusFilter.map((value) => `&statusFilter=${value}`).join('')
      url += stringData
    }
    result = await httpService.get(url)
    return result.data
  }

  public async getTeamMembers(companyId: string, employeeId: string) {
    let httpService = this.container.get<HttpService>(HttpService)
    var url = `${this.baseUrl}/${companyId}/${employeeId}/teamMembers` 
    const result = await httpService.get<any>(url)
    let data = result.data as EmployeeBrief[]
    return data
  }

  public async getProjects(query: Query, companyId: string) {
    let httpService = this.container.get<HttpService>(HttpService)     
    const result = await httpService.get<any>(`${process.env.PUBLIC_URL}/api/v1/companies/${companyId}/projects?${DataStore.buildUrl(query)}`)
    return result.data
  }

  public async GetTimeSheets(companyId: string, employeeId: string, showMyTeam: boolean, fromDate?: string, toDate?: string, projectFilter: string[] = []) {
    let httpService = this.container.get<HttpService>(HttpService)
    var result

    var filter = projectFilter.length > 0 ? {
      'Tasks': {
        any: {
          'ProjectTask': {
            'Project': {
              'Title': {
                in: projectFilter
              }
            }
          }
        }
      }
    } : undefined

    var query: Query = {
      searchQuery: '',
      skip: 0,
      take: 999,
      filter: filter
      }
      result = await httpService.get<QueryResult<TimesheetSummary>>(`${this.baseUrl}/${companyId}/${employeeId}/summary?${DataStore.buildUrl(query)}`, { showMyTeam: showMyTeam, from: fromDate, to: toDate })
    let timesheets = result.data.items.map((item: any, index: number) => {
      let timesheet = {
        ...item,
        fromDate: unixEpochToDate(item.fromDate),
        toDate: unixEpochToDate(item.toDate)
      } as TimesheetItem
      return timesheet
    })
    return timesheets
  }

}
